const BUNDLE_LINK_PREFIX = "/a/loop_subscriptions/bundle",
  LOOP_BUNDLE_URL = "https://api-service.loopwork.co/bundleTransaction/getBundleCartDetails",
  LOOP_API_SERVICE_URL = "https://api-service.loopwork.co";
let BUNDLE_CONTAINER_CLASS = "BUNDLE_CONTAINER_CLASS",
  CART_SUBTOTAL_CLASS = "CART_SUBTOTAL_CLASS";
const getItemsHtmlLoop = (item, bundleQuantityMapping) => {
    let quantity = item.quantity;
    if (bundleQuantityMapping) {
      let variant = bundleQuantityMapping.find((v) => v.childProductId === item.id);
      variant && (quantity = variant.quantity);
    }
    return `<p><span style="display:block;" class="data-cart-item-selling-plan-name">${item.title || ""} x ${quantity || ""}</span></p>`;
  },
  getEditCartButton = (
    bundleTransactionId,
    editBtnText = "Edit",
  ) => `<button onclick="event.preventDefault(); changeBundleCartItems('${bundleTransactionId}');" style="background:none;border:none;display:flex;align-items:center;gap:3px;cursor:pointer;padding:0; text-decoration:underline;">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pen" viewBox="0 0 17 17">
            <path fill-rule="evenodd" d="M15.655 4.344a2.695 2.695 0 0 0-3.81 0l-.599.599-.009-.009-1.06 1.06.008.01-5.88 5.88a2.75 2.75 0 0 0-.805 1.944v1.922a.75.75 0 0 0 .75.75h1.922a2.75 2.75 0 0 0 1.944-.806l7.54-7.539a2.695 2.695 0 0 0 0-3.81Zm-4.409 2.72-5.88 5.88a1.25 1.25 0 0 0-.366.884v1.172h1.172c.331 0 .65-.132.883-.366l5.88-5.88-1.689-1.69Zm2.75.629.599-.599a1.195 1.195 0 1 0-1.69-1.689l-.598.599 1.69 1.689Z"></path>
        </svg>
        <p style="padding:0px;margin:0px;margin-top:5px">${editBtnText ?? "Edit"}</p>
    </button>`;
function formatBundlePriceLoop(value) {
  const symbol = typeof value === "string" ? (value.match(/^[^0-9.-]+/) || [""])[0] : "";
  const num =
    typeof value === "number" ? value : parseFloat(String(value).replace(/[^0-9.-]/g, ""));
  return isNaN(num) ? value : symbol + num.toFixed(2);
}
const getBundleCartTableTemplateLoop = (bundleItem, index, bundleLink) => `
        <tr role="row" class="cart-items__table-row" id="CartBundleItem-${index}" data-parent-key="" data-key="bundle:${bundleItem.bundleId}">
    <td class="cart-items__media" role="cell" headers="productImage">
        <a href="${bundleLink}" class="cart-items__media-container" style="--ratio:0.8;">
            <img src="${bundleItem.image || ""}" class="cart-items__media-image" alt="" loading="lazy" width="150" height="94">
        </a>
    </td>

    <td class="cart-items__details cart-primary-typography" role="cell" headers="productInformation">
        <p><a href="" class="cart-items__title">${bundleItem.label}</a></p>
        <dl class="cart-items__variants"></dl>
        <ul class="list-unstyled" role="list">
            ${bundleItem.items.map((item) => getItemsHtmlLoop(item)).join("")}
        </ul>
        <p class="product-option">${bundleItem.sellingPlan || ""}</p>
        <ul class="discounts list-unstyled" role="list" aria-label="Discount"></ul>
        ${getEditCartButton(bundleItem.bundleId, bundleItem.editBtnText)}
        <div>
            <span class="visually-hidden">Sale price</span>
            <span>${formatBundlePriceLoop(bundleItem.price)}</span>
        </div>
    </td>

    <td class="cart-items__quantity" role="cell" headers="quantity">
      <quantity-selector-component class="quantity-selector cart-primary-typography">
        <button class="button quantity-minus button-unstyled" type="button" name="minus" disabled>
          <span class="visually-hidden">Decrease quantity</span>
        </button>
        <input disabled class="quantity__input" type="number" value="1" min="0">
        <button class="button quantity-plus button-unstyled" type="button" name="plus" disabled>
          <span class="visually-hidden">Increase quantity</span>
        </button>
      </quantity-selector-component>
      <button class="button button--tertiary cart-items__remove" type="button" aria-label="${bundleItem.label}" onclick="removeBundleLoop(\'${bundleItem.bundleId}\')">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" role="presentation" class="icon icon-remove">
                <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
            </svg>
        <span class="visually-hidden">Remove</span>
      </button>
    </td>

    <td class="cart-items__price cart-secondary-typography" role="cell" headers="productTotal">
      <text-component value="${formatBundlePriceLoop(bundleItem.price)}">${formatBundlePriceLoop(bundleItem.price)}</text-component>
    </td>
  </tr>
    `,
  getBundleCartDrawerTemplateLoop = (bundleItem, index, bundleLink) => `
        <tr class="cart-item" id="CartBundleItem-${index}">
          <td class="cart-item__media" style="text-align:center;">
            <img class="cart-item__image"
              src="${bundleItem.image || ""}"
              alt="${bundleItem.label}" loading="lazy" width="75" height="75">
          </td>
          <td class="cart-item__details">
            <a href="${bundleLink}"
              class="cart-item__name break">
              ${bundleItem.label || ""}
            </a>
            <dl>
              <div class="product-option">
                ${bundleItem.items.map((item) => getItemsHtmlLoop(item)).join("")}
                  <br/>
                  <p><span class="data-cart-item-selling-plan-name">
                    ${bundleItem.sellingPlan || ""}
                  </span></p>
              </div>
            </dl>
          </td>
          <td class="cart-item__quantity small-hide">
            ${bundleItem.quantity}
          </td>
          <td class="right medium-hide large-up-hide">
            <div class="cart-item__price-wrapper medium-up" style="display: flex; gap: 10px;">
              ${
                bundleItem.priceWithoutDiscount !== bundleItem.price
                  ? `<span class="price price--end" style="text-decoration:line-through;">
                    ${bundleItem.priceWithoutDiscount}
                </span>`
                  : ""
              }
              <span class="price price--end" style="font-weight: 600;">
                ${bundleItem.price}
              </span>
            </div>
            ${getEditCartButton(bundleItem.bundleId, bundleItem.editBtnText)}
            <div onclick="removeBundleLoop('${bundleItem.bundleId}')" style="cursor:pointer; width: fit-content;height: 15px;display: inline-flex;flex-direction: row-reverse;">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style="width: 1em; height: 1em;" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">
                    <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                    <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
              </svg>
            </div>
          </td>
        </tr>
    `,
  getBundleCartItemsDivTemplateLoop = (bundleItem, index, bundleLink) => `
        <div style="display:flex; gap:20px; justify-content: space-between;" id="CartBundleItem-${index}">
          <div style="display:flex; gap:20px;">
            <div style="text-align:center;">
              <img
                src="${bundleItem.image || ""}"
                alt="${bundleItem.label}" loading="lazy" width="75" height="75">
            </div>
            <div>
              <a href="${bundleLink}"
                 style="font-weight:600">
                ${bundleItem.label || ""}
              </a>
              <div>
                ${bundleItem.items.map((item) => getItemsHtmlLoop(item)).join("")}
                  <br/>
                  <p><span>${bundleItem.sellingPlan || ""}</span></p>
              </div>
            </div>
          </div>
          <div>
            ${bundleItem.quantity}
          </div>
          <div>
            <div style="display: flex; gap: 10px;">
                ${
                  bundleItem.priceWithoutDiscount !== bundleItem.price
                    ? `<span style="text-decoration:line-through;">
                        ${bundleItem.priceWithoutDiscount}
                    </span>`
                    : ""
                }
              <span style="font-weight: 600;">${bundleItem.price}</span>
            </div>
            ${getEditCartButton(bundleItem.bundleId, bundleItem.editBtnText)}
            <div onclick="removeBundleLoop('${bundleItem.bundleId}')" style="cursor:pointer; vertical-align: text-top; width: fit-content;height: 15px;display: inline-flex;flex-direction: row-reverse;">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style="width: 1em; height: 1em;" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove">
                    <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                    <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
              </svg>
            </div>
          </div>
        </div>
    `,
  getPresetBundleCartTemplateLoop = (bundleItem, index, bundleLink) => `
        <tr role="row" class="cart-items__table-row" id="CartBundleItem-${index}" data-parent-key="" data-key="bundle:${bundleItem.bundleId}">
    <td class="cart-items__media" role="cell" headers="productImage">
        <a href="${bundleLink}" class="cart-items__media-container" style="--ratio:0.8;">
            <img src="${bundleItem.image || ""}" class="cart-items__media-image" alt="" loading="lazy" width="150" height="94">
        </a>
    </td>

    <td class="cart-items__details cart-primary-typography" role="cell" headers="productInformation">
        <p><a href="${bundleLink}" class="cart-items__title">${bundleItem.label}</a></p>
        <dl class="cart-items__variants"></dl>
        <ul class="list-unstyled" role="list">
            ${bundleItem.items.map((item) => getItemsHtmlLoop(item, bundleItem.bundleQuantityMapping)).join("")}
        </ul>
        <p class="product-option">${bundleItem.sellingPlan || ""}</p>
        ${
          bundleItem.discountTitle
            ? `<ul class="discounts list-unstyled" role="list" aria-label="Discount">
            <li class="discounts__discount">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-text" width="12" height="12" viewBox="0 0 12 12">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor">
                    </path>
                </svg>
                ${bundleItem.discountTitle}
            </li>
        </ul>`
            : ""
        }
        ${getEditCartButton(bundleItem.bundleId, bundleItem.editBtnText)}
        <div>
            <span class="visually-hidden">Sale price</span>
            <span>${formatBundlePriceLoop(bundleItem.final_line_price_currency)}</span>
        </div>
    </td>

    <td class="cart-items__quantity" role="cell" headers="quantity">
      <quantity-selector-component class="quantity-selector cart-primary-typography">
        <button class="button quantity-minus button-unstyled" type="button" name="minus" disabled>
          <span class="visually-hidden">Decrease quantity</span>
        </button>
        <input disabled class="quantity__input" type="number" value="${bundleItem.bundleProductQuantity}" min="0">
        <button class="button quantity-plus button-unstyled" type="button" name="plus" disabled>
          <span class="visually-hidden">Increase quantity</span>
        </button>
      </quantity-selector-component>
      <button class="button button--tertiary cart-items__remove" type="button" aria-label="${bundleItem.label}" onclick="removeBundleLoop(\'${bundleItem.bundleId}\')">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" role="presentation" class="icon icon-remove">
                <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
            </svg>
        <span class="visually-hidden">Remove</span>
      </button>
    </td>

    <td class="cart-items__price cart-secondary-typography" role="cell" headers="productTotal">
      <text-component value="${formatBundlePriceLoop(bundleItem.final_line_price_currency)}">${formatBundlePriceLoop(bundleItem.final_line_price_currency)}</text-component>
    </td>
  </tr>
    `,
  getPresetBundleCartDrawerTemplateLoop = (bundleItem, index, bundleLink) => `
        <tr class="cart-item" id="CartBundleItem-${index}">
    <td class="cart-item__media">
        <a href="${bundleLink}" class="cart-item__link" aria-hidden="true" tabindex="-1"> </a>
          <div class="cart-item__image-container gradient global-media-settings">
            <img src="${bundleItem.image || ""}"  class="cart-item__image" alt="" loading="lazy" width="150" height="94">
          </div>
    </td>

    <td class="cart-item__details"><a href="${bundleLink}" class="cart-item__name h4 break">${bundleItem.label}</a>
                <div class="product-option">
            ${bundleItem.items.map((item) => getItemsHtmlLoop(item, bundleItem.bundleQuantityMapping)).join("")}
              <br/>
        </div>
        <div class="product-option">
         ${bundleItem.eachBundleAmount}
        </div><dl></dl>

        <p class="product-option">${bundleItem.sellingPlan || ""}</p>
        ${
          bundleItem.discountTitle
            ? `<ul class="discounts list-unstyled" role="list" aria-label="Discount">
            <li class="discounts__discount">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-text" width="12" height="12" viewBox="0 0 12 12">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor">
                    </path>
                </svg>
                ${bundleItem.discountTitle}
            </li>
        </ul>`
            : ""
        }
    </td>

    <td class="cart-item__totals right medium-hide large-up-hide">
      <div class="cart-item__price-wrapper"><span class="price price--end">
           ${bundleItem.final_line_price}
          </span></div>
    </td>

    <td class="cart-item__quantity">
      <div class="cart-item__quantity-wrapper">
        <quantity-input class="quantity">
          <input disabled class="quantity__input" type="number" value="${bundleItem.bundleProductQuantity}" min="0">
        </quantity-input>
        <cart-remove-button>
          <a onclick="removeBundleLoop('${bundleItem.bundleId}')" class="button button--tertiary" aria-label="${bundleItem.label}" style="cursor : pointer">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" role="presentation" class="icon icon-remove">
                <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
            </svg>
          </a>
        </cart-remove-button>
      </div>
    </td>

    <td class="cart-item__totals right small-hide">
      <div class="cart-item__price-wrapper"><span class="price price--end">
           ${bundleItem.final_line_price_currency}
          </span></div>
    </td>
  </tr>
    `,
  getItemKeysByBundleIdLoop = (bundleId) => {
    const cartItems = window.Loop.bundleCartAllItems,
      data = { updates: {} };
    for (const item of cartItems) {
      const _bundleId = item?.properties?._bundleId ?? item?.properties?.bundleId;
      !_bundleId || _bundleId !== bundleId || (data.updates[item.key] = 0);
    }
    return data;
  },
  removeBundleLoop = async (bundleId) => {
    const data = getItemKeysByBundleIdLoop(bundleId),
      endpoint = `${window.Shopify.routes.root}cart/update.js`;
    (await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    }),
      (window.location.href = window.location.href));
  },
  changeBundleCartItems = async (bundleTransactionId) => {
    disableEditButton();
    const currentLocale = window?.Shopify?.locale,
      root = window?.Shopify?.routes?.root ?? "/";
    if (bundleTransactionId) {
      const _editBundleRef = `${BUNDLE_LINK_PREFIX}/change/${bundleTransactionId}`;
      currentLocale && root !== "/"
        ? (window.location.href = `/${currentLocale}${_editBundleRef}`)
        : (window.location.href = _editBundleRef);
    }
  },
  disableEditButton = (bundleId) => {
    console.log(`disabling bundle edit button: ${bundleId}`);
    const editButttons = document.querySelectorAll(`loop-edit-bundle-${bundleId}`);
    for (const button of editButttons) button.disabled = !0;
  },
  fetchLoopBundleTransactionCartDetails = async (loopBundleGuid) => {
    const { locale } = window.Shopify,
      _locale = locale.split("-")[0],
      _endpoint = `${LOOP_BUNDLE_URL}/${loopBundleGuid}?locale=${_locale}`;
    return await (await fetch(_endpoint)).json();
  },
  addExtraDetailsToBundleItemsLoop = async (bundleItems) => {
    let totalDiscount = 0,
      currencySymbol = "",
      currency = "";
    const fetchDetailsPromises = bundleItems.map((bundleItem) =>
        fetchLoopBundleTransactionCartDetails(bundleItem.bundleId),
      ),
      allExtraDetails = await Promise.all(fetchDetailsPromises);
    for (let i = 0; i < allExtraDetails.length; ++i) {
      const extraDetails = allExtraDetails[i],
        bundleItem = bundleItems[i],
        quantityMapping = extraDetails?.variantMap?.[bundleItem.bundleId] ?? [],
        isPresetBundleProduct = bundleItem.isPresetBundleProduct,
        totalBundleItemsQuantity = bundleItem.items.reduce((acc, item) => acc + item.quantity, 0);
      let price = isPresetBundleProduct ? bundleItem.discounted_price : bundleItem.price;
      ((bundleItem.label = extraDetails?.label),
        (bundleItem.image = extraDetails?.image),
        (bundleItem.sellingPlan = extraDetails?.name),
        (bundleItem.editBtnText = extraDetails.editBtnText ?? "Edit"),
        (bundleItem.priceWithoutDiscount = `${extraDetails.currencySymbol}${price.toFixed(2)}`),
        (bundleItem.final_line_price_currency = `${extraDetails.currencySymbol}${parseFloat(bundleItem.final_line_price).toFixed(2)}`),
        (bundleItem.loopBundleId = extraDetails.loopBundleId),
        (currencySymbol = extraDetails.currencySymbol),
        (currency = extraDetails.currency),
        extraDetails.discountType &&
          extraDetails.discountValue &&
          !isPresetBundleProduct &&
          (extraDetails.discountType === "PERCENTAGE"
            ? extraDetails.appliesOnEachItem
              ? ((totalDiscount +=
                  price *
                  (parseFloat(extraDetails.discountValue) / 100) *
                  totalBundleItemsQuantity),
                (price =
                  price -
                  price *
                    (parseFloat(extraDetails.discountValue) / 100) *
                    totalBundleItemsQuantity))
              : ((totalDiscount += price * (parseFloat(extraDetails.discountValue) / 100)),
                (price = price - price * (parseFloat(extraDetails.discountValue) / 100)))
            : extraDetails.appliesOnEachItem
              ? ((totalDiscount +=
                  parseFloat(extraDetails.discountValue) * totalBundleItemsQuantity),
                (price = price - parseFloat(extraDetails.discountValue) * totalBundleItemsQuantity))
              : ((totalDiscount += parseFloat(extraDetails.discountValue)),
                (price = price - parseFloat(extraDetails.discountValue)))),
        (bundleItem.price = `${extraDetails.currencySymbol}${parseFloat(price).toFixed(2)}`),
        extraDetails?.productsQuantity
          ? ((bundleItems[i].bundleProductQuantity = extraDetails.productsQuantity),
            (bundleItems[i].eachBundleAmount =
              `${extraDetails.currencySymbol}${parseFloat(bundleItems[i].final_line_price / extraDetails.productsQuantity).toFixed(2)}`))
          : ((bundleItems[i].bundleProductQuantity = 1),
            (bundleItems[i].eachBundleAmount =
              `${extraDetails.currencySymbol}${parseFloat(price / 1).toFixed(2)}`)),
        quantityMapping.length && (bundleItem.bundleQuantityMapping = quantityMapping),
        isPresetBundleProduct && (bundleItem.productHandle = extraDetails.product_handle));
    }
    removeDiscountFromSubtotalInCartLoop(totalDiscount, currencySymbol, currency);
  },
  removeDiscountFromSubtotalInCartLoop = (totalDiscount, currencySymbol, currency) => {
    let targetNode = null;
    ((targetNode = document.querySelector(".totals__subtotal-value")),
      targetNode &&
        applyDiscountByCartLineItemsLoop(targetNode, totalDiscount, currencySymbol, currency));
  };
function applyDiscountByCartLineItemsLoop(element, discount, currencySymbol, currency) {
  const discountedPrice = (
    (
      window.Loop.bundleCartAllItems.reduce(
        (acc, item) =>
          acc +
          (item.properties._isPresetBundleProduct ? item.discounted_price : item.price) *
            item.quantity,
        0,
      ) / 100
    ).toFixed(2) - discount
  ).toFixed(2);
  isNaN(discountedPrice) ||
    (element.innerHTML = `${currencySymbol ?? ""}${discountedPrice} ${currency ?? ""}`);
}
const getBundleItemsLoop = (items) => {
    const bundleItemsMap = {};
    for (const item of items) {
      const bundleId = item?.properties?._bundleId ?? item?.properties?.bundleId;
      bundleId &&
        (Object.hasOwn(bundleItemsMap, bundleId)
          ? ((bundleItemsMap[bundleId].price += (Number(item.price) * Number(item.quantity)) / 100),
            (bundleItemsMap[bundleId].discounted_price +=
              (Number(item.discounted_price) * Number(item.quantity)) / 100),
            (bundleItemsMap[bundleId].amount += (Number(item.price) * Number(item.quantity)) / 100),
            (bundleItemsMap[bundleId].final_line_price += Number(item.final_line_price) / 100),
            bundleItemsMap[bundleId].items.push(item))
          : (bundleItemsMap[bundleId] = {
              bundleId,
              quantity: 1,
              price: (Number(item.price) * Number(item.quantity)) / 100,
              amount: (Number(item.price) * Number(item.quantity)) / 100,
              items: [item],
              discounted_price: (Number(item.discounted_price) * Number(item.quantity)) / 100,
              isPresetBundleProduct: item?.properties?._isPresetBundleProduct,
              discountTitle: item?.discounts?.[0]?.title ?? "",
              final_line_price: Number(item.final_line_price) / 100,
            }));
    }
    return sortItemsByTitleLoop(Object.values(bundleItemsMap));
  },
  sortItemsByTitleLoop = (bundles) =>
    bundles.map(
      (bundle) => (
        bundle.items.sort((a, b) => {
          let titleA = a.title.toUpperCase(),
            titleB = b.title.toUpperCase();
          return titleA < titleB ? -1 : titleA > titleB ? 1 : 0;
        }),
        bundle
      ),
    ),
  renderBundleItemsLoop = (bundleItems, clientId) => {
    let _parent = document.querySelector(`.${clientId}`);
    if ((_parent || (_parent = document.querySelector(`.${BUNDLE_CONTAINER_CLASS}`)), !!_parent))
      for (let i = 0; i < bundleItems.length; ++i) {
        let bundleItem = bundleItems[i];
        const _bundleLink = bundleItem.isPresetBundleProduct
          ? `https://${window.Shopify.shop}/products/${bundleItem.productHandle}`
          : `${BUNDLE_LINK_PREFIX}/${bundleItem.loopBundleId}`;
        let _template,
          hasTable = document.getElementsByTagName("table");
        (bundleItem.isPresetBundleProduct && window.location.pathname === "/cart"
          ? (_template = getPresetBundleCartTemplateLoop(bundleItem, i + 1, _bundleLink))
          : bundleItem.isPresetBundleProduct && window.location.pathname !== "/cart"
            ? (_template = getPresetBundleCartDrawerTemplateLoop(bundleItem, i + 1, _bundleLink))
            : clientId.includes("drawer") && hasTable.length
              ? (_template = getBundleCartDrawerTemplateLoop(bundleItem, i + 1, _bundleLink))
              : hasTable.length
                ? (_template = getBundleCartTableTemplateLoop(bundleItem, i + 1, _bundleLink))
                : (_template = getBundleCartItemsDivTemplateLoop(bundleItem, i + 1, _bundleLink)),
          (_parent.innerHTML = `${_template} ${_parent.innerHTML}`));
      }
  };
async function getCartItemsLoop() {
  const url = `https://${Shopify.cdnHost.split("/cdn")[0]}/cart.json`;
  return (await (await fetch(url)).json())?.items ?? [];
}
function setupMutationLoop(_bundleItems) {
  if (!_bundleItems?.length || window.location.pathname.includes("/a/loop_subscriptions/bundle"))
    return;
  let previousQuantity = window.Loop.bundleCartAllItems.reduce(
      (acc, curr) => acc + curr.quantity,
      0,
    ),
    timeoutId;
  const handleChanges = async () => {
    (await getCartItemsLoop()).reduce((acc, curr) => acc + curr.quantity, 0) !== previousQuantity &&
      window.location.reload();
  };
  let targetNodes = document.querySelectorAll("form");
  const config = { childList: !0, subtree: !0 };
  targetNodes.forEach((targetNode) => {
    new MutationObserver(() => {
      (clearTimeout(timeoutId), (timeoutId = setTimeout(handleChanges, 500)));
    }).observe(targetNode, config);
  });
}
function setupMutationIfElementDelete() {
  let firstChange = !0,
    timeoutId;
  const handleChanges = () => {
    firstChange
      ? (firstChange = !1)
      : window.location.pathname.includes("/a/loop_subscriptions/bundle") ||
        ((firstChange = !0), window.location.reload());
  };
  let targetNode = document.querySelector(".cart-container");
  if ((targetNode || (targetNode = document.querySelector(".cart__blocks")), !targetNode)) return;
  const observer = new MutationObserver(() => {
      (clearTimeout(timeoutId), (timeoutId = setTimeout(handleChanges, 1e3)));
    }),
    config = { childList: !0, subtree: !0 };
  observer.observe(targetNode, config);
}
function setupMutationOldLoop() {
  var firstChange = !0;
  let targetNode = null,
    observerNode = null;
  if (
    ((targetNode = document.querySelectorAll("[data-cart-subtotal]")),
    (targetNode && targetNode.length > 1) || !targetNode.length
      ? (observerNode = document.querySelector(`.${CART_SUBTOTAL_CLASS}`))
      : (observerNode = targetNode[0]),
    !observerNode)
  )
    return;
  const config = { attributes: !0, childList: !0, subtree: !0 },
    callback = (mutationList, observer2) => {
      if (firstChange) {
        firstChange = !1;
        return;
      } else ((firstChange = !0), setTimeout(window.location.reload(), 1e3));
    };
  new MutationObserver(callback).observe(observerNode, config);
}
const initLoopBundle = async (clientId) => {
  console.log(`Loop Bundle Initialized for ${clientId}`);
  const _cartItems = window.Loop.bundleCartAllItems,
    _bundleItems = getBundleItemsLoop(_cartItems);
  (await addExtraDetailsToBundleItemsLoop(_bundleItems),
    setupMutationLoop(_bundleItems),
    renderBundleItemsLoop(_bundleItems, clientId));
};
//# sourceMappingURL=/s/files/1/0647/5513/8673/t/4/assets/loop_bundle.js.map?v=1771527315
//# sourceMappingURL=/s/files/1/0647/5513/8673/t/4/assets/loop_bundle.js.map?v=1771527315